import { useEffect, useRef } from "react";
import { subscribe } from "../services/realtime";

/**
 * Runs `handler` whenever the shop's live connection announces `event`.
 * The latest handler is always used, so it may close over fresh state.
 */
export const useShopEvent = (event, handler) => {
  const latest = useRef(handler);

  useEffect(() => {
    latest.current = handler;
  });

  useEffect(
    () => subscribe(event, (payload) => latest.current(payload)),
    [event],
  );
};
